import { ScrollTrigger } from "@gsap";

document.addEventListener("DOMContentLoaded", () => {
	const header = document.querySelector("header.pk-header");
	if (!header) return;

	const threshold = 200;

	ScrollTrigger.create({
		start: 0,
		end: "max",
		onUpdate(self) {
			const menuOpen = header.querySelector(".pk-menu .menu.open");
			const inUse = header.matches(":hover, :focus-within");
			const hide = self.scroll() > threshold && self.direction === 1 && !menuOpen && !inUse;

			header.classList.toggle("header-hidden", hide);
		},
	});
});
